import { languageToLocale } from '@becurious/languagetolocale';
import applyTracking from '@becurious/applytracking';

export default class MewsWidget {
	/**
	 * Constructor
	 *
	 * @param {Object} options Configuration options
	 */
	constructor({ configurationIds, hotelID, gtmID, primaryColor = '#222' }) {
		if (typeof window.Mews === 'undefined') {
			console.error('You need to load the Mews distributor script first');

			return;
		}

		if (typeof configurationIds === 'undefined' && typeof hotelID === 'undefined') {
			console.error('You need to set either the hotelID or the configurationIds');

			return;
		}

		configurationIds ?? (configurationIds = [hotelID]);
		this.standaloneUrl = `https://app.mews.com/distributor/${configurationIds.join(';')}`;
		this.fallbackLanguage = 'en';

		this.config = {
			configurationIds,
			gtmContainerId: gtmID,
			ecommerce: true,
			hashEvents: true,
			theme: {
				primaryColor,
			},
		};

		window.Mews.Distributor(this.config, (distributor) => {
			this.mews = distributor;
		});
	}

	/**
	 * Convert a string representation of a date to a date object
	 *
	 * @param {*} date Date as an object or string
	 * @returns {Date} Date as an object
	 */
	stringToDate(date) {
		if (typeof date === 'string') {
			return new Date(date);
		}

		return date;
	}

	/**
	 * Open the booking engine
	 *
	 * @param {object} options  Options object
	 *
	 * @return {void}
	 */
	visitUrl(options) {
		if (!options.language) {
			options.language = this.fallbackLanguage;
		}

		if (!this.mews) {
			window.open(applyTracking(this.standaloneUrl));

			return;
		}

		this.mews.setLanguageCode(languageToLocale(options.language).replace('_', '-'));

		if (options.arrival) {
			options.arrival = this.stringToDate(options.arrival);
		}

		if (options.departure) {
			options.departure = this.stringToDate(options.departure);
		}

		if (options.arrival && options.departure && options.roomID) {
			this.mews.setStepRates(
				options.roomID,
				options.arrival,
				options.departure,
				options.promo ? options.promo : null,
			);
		} else if (options.arrival && options.departure) {
			this.mews.setStepRooms(options.arrival, options.departure, options.promo ? options.promo : null);
		} else {
			if (options.arrival) {
				this.mews.setStartDate(options.arrival);
			}

			if (options.departure) {
				this.mews.setEndDate(options.departure);
			}

			if (options.promo) {
				this.mews.setVoucherCode(options.promo);
			}

			if (options.roomID) {
				this.mews.setRooms([options.roomID]);
			}
		}

		this.mews.open();
	}
}
